module.exports = __webpack_public_path__ + "img/slider-image-sm-3.0b34adb5.jpg";